// extracted by mini-css-extract-plugin
export var autoWidth = "swiper-module--autoWidth--25d21";
export var sliderBelow = "swiper-module--sliderBelow--b476d";
export var swiper = "swiper-module--swiper--16282";
export var swiperPagination = "swiper-module--swiperPagination--17220";